import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { LicenseSeatsdataSourceElement, LicenseSeatsRoleDataSourceElement } from '../license-seats.datasource';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export enum RemoveUserAction {
	REMOVE_FROM_COURSE,
	REMOVE_FROM_ALL_COURSES
}

export interface RemoveUserConfirmDialogData {
	user: LicenseSeatsdataSourceElement;
	role?: LicenseSeatsRoleDataSourceElement;
	action: RemoveUserAction;
	dialogTitleId?: string;
}

@Component({
	selector: 'app-remove-user-confirm-dialog',
	templateUrl: './remove-user-confirm-dialog.component.html',
	standalone: false
})
export class RemoveUserConfirmDialogComponent {
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<RemoveUserConfirmDialogData>
	): MatDialogRef<RemoveUserConfirmDialogComponent, boolean> {
		const dialogTitleId = config?.data?.dialogTitleId ?? RemoveUserConfirmDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, RemoveUserConfirmDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `remove-user-confirm-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public constructor (
		public dialogRef: MatDialogRef<RemoveUserConfirmDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) public dialogData: RemoveUserConfirmDialogData
	) {
		this.dialogData.dialogTitleId ??= RemoveUserConfirmDialogComponent.getDialogTitleId();
	}

	public get isSingleCourseRemoval () {
		return this.dialogData.action === RemoveUserAction.REMOVE_FROM_COURSE;
	}

	public cancel () {
		this.dialogRef.close(false);
	}

	public confirm () {
		this.dialogRef.close(true);
	}
}
